export default "__VITE_ASSET__DJdOa9lm__"